import getDefaultState from './moduleDashState'
import Vue from 'vue'
import router from '../../router'
import { initFBShowcaseWdgts  } from '../../methods/fetchEntityData.js'
import {emptyViewData, emptyViewState} from './emptyStateMethods'

export default { 

  'SET_BUILD_WIDGETS_TIMEOUT' (state, payload) {

    if (state.viewData.buildWidgetsTimeout) clearTimeout(state.viewData.buildWidgetsTimeout)
    state.viewData.buildWidgetsTimeout = payload

  },

  'SHOW_PREVIEW' (state) {
    state.viewState.showPreview = true
  },
  'HIDE_PREVIEW' (state) {
    state.viewState.showPreview = false
  },
  'SHOWCASE_OPERATION_IN_PROGRESS' (state, payload) {
    state.showcaseOperationInProgress = payload
  },
  'SHARE_SELECTED' (state,what) {
    state.viewState.checkedShares.push(what)
  },
  'CHANGE_BRAND' (state, payload) {
    state.logoURL = payload.brandLogo
    state.brandHex = payload.brandHex
  },
  'CHANGE_PAGE_VIEW_FILTER' (state, payload) {
    if (state.viewState.viewResponseFilters.page[payload.filter] !== payload.value) state.viewState.viewResponseFilters.page[payload.filter] = payload.value
  },
  'CHANGE_VIEW_FILTER' (state, payload) {
    /*
    {
      filter: ...see below,
      value: ...
    }    
    defaults:
      startTime: new Date().getTime() * 1000,
      endTime: new Date().getTime() * 1000,            
      showPositive: true,
      showNeutral: true,
      showNegative: true,
      showNoRating: true,
      showSpam: false,
      filterWords: false
    */
    
    if (state.viewState.viewResponseFilters[payload.filter] !== payload.value) state.viewState.viewResponseFilters[payload.filter] = payload.value

  },
  'CHANGE_QUESTIONS_WITH_RESPONSES' (state, payload) {
    state.viewData.questionsWithResponses = payload
  },
  'SYNC_INITIAL_SHOWCASED_IDs' (state, payload) {

    //for the "VIEW" pages, need to know what ids are currently on showcase

    //console.log(payload)

    payload.forEach((itm) => {
      itm.taggedWith.forEach((tag) => {
        if (!state.viewData.currentTags.includes(tag)) state.viewData.currentTags.push(tag)
      })      
    })
    state.viewData.currentShowcasedIDs = [...payload]       

    if (!state.viewState.showcaseDataLoaded) state.viewState.showcaseDataLoaded = true    
    
  },  
  'SYNC_WIDGETS' (state, payload) {  

    //the actual filtered showcase results

    const widgets = []
    payload.data.forEach((w) => {
      if (typeof w.markedForDelete === 'undefined') widgets.push(w)
    })
    state.viewData.currentWidgets = widgets

    if (!state.viewState.widgetsLoaded) state.viewState.widgetsLoaded = true        

  },
  'CHANGE_CREATE_TAG_TEXT' (state, payload) {
    state.viewState.createTagText = payload
  },
  'TOGGLE_SHOW_CREATE_TAG' (state, confirmCall = false) {
    if (!confirmCall) {
      state.viewState.showCreateTagModal = false      
      state.viewState.createTagCall = () => {}
    } else {
      state.viewState.createTagText = ''
      state.viewState.showCreateTagModal = true
      state.viewState.createTagCall = confirmCall
    } 
  },
  'MARK_SHOWCASE_ITEM' (state, payload) {
    //Add or remove item 
    //add or remove tag (if tag is present)
      
    /*
    type: ‘rvw’ | ‘fbck’,
    rvwOrSnID: string,
    intent: boolean ,
    tag: string | false,
    jFI = null
    */

    //console.log(payload)

    //if intent is true
    const tag = payload.tag
    const itemID = payload.type === 'feedback' || payload.type === 'testimonial' ? `${payload.rvwOrSnID}_${payload.jFI}` : payload.rvwOrSnID
    
    //console.log(payload)
    //console.log(typeof tag)

    //check if item maybe already exists
    const itemIndex = state.viewData.currentShowcasedIDs.findIndex(itm => itm.id === itemID)        

    if (payload.intent) {                
        //add item, or add tag
        //does item exist?
        
        if (itemIndex > -1) {
          const item = state.viewData.currentShowcasedIDs[itemIndex]
          //item exists, check if we should add tag
          if (tag && !item.taggedWith.includes(tag)) {                                
              //we should add tag, replace with a new item
              const newItem = {...item}  
              newItem.taggedWith.push(tag)
              state.viewData.currentShowcasedIDs.splice(itemIndex, 1, newItem)            
          }
        } else {

        //item doesnt exist, add it
        state.viewData.currentShowcasedIDs.push({
            id: itemID,
            taggedWith: tag ? [tag] : []
          })

        }   


        //lastly, check if tag exists in tagrecord, if not add it
        if (tag && !state.viewData.currentTags.includes(tag)) state.viewData.currentTags.push(tag)


    } else {

      if (itemIndex > -1) {
        const item = state.viewData.currentShowcasedIDs[itemIndex]
        //are we removing tag, or removing item?
        if (tag) {
          
          const newItem = {...item}          
          const tagIndex = newItem.taggedWith.indexOf(tag)
          
          if (tagIndex > -1) {
            newItem.taggedWith.splice(tagIndex, 1)
            state.viewData.currentShowcasedIDs.splice(itemIndex, 1, newItem)
          }

        } else {
          //remove item          
          state.viewData.currentShowcasedIDs.splice(itemIndex, 1)
        }
      }

    } 

  },
  'IS_PROCESSING_PAYMENT' (state) {
    state.viewState.processingPayment = true
  },
  'TOGGLE_REVIEWS_LOADING' (state, payload) {
    state.viewData.reviews[payload.platform].loading = payload.value
  },
  'POPULATE_REVIEWS' (state, payload) {
    if (payload.isReset) {
      state.viewData.reviews[payload.platform].reviews = []
      state.viewData.reviews[payload.platform].currentThreshold = 50
    }
    state.viewData.reviews[payload.platform].currentThreshold = state.viewData.reviews[payload.platform].currentThreshold + 50
    state.viewData.reviews[payload.platform].reviews = state.viewData.reviews[payload.platform].reviews.concat(payload.reviews)
  },
  'DONE_PROCESSING_PAYMENT' (state) {
    state.viewState.processingPayment = false
  },
  'SIGNOUT' (state) {
    state.validLoggedInLoaded = false
    state.loggedInUser = {
      authID: '',
      firstName: '',
      lastName: '',
      contactNumber: {},
      emailAddress: '',
      lastAccessed: false //BEFORE NOW
    }
    state.viewData =  {
        isNewUser: true,
        business: {
          name: '',
          businessID: '',
          feedbackAddressHandle: ''
        },
        sentimentSummary: {
          type: '30day',
          old: 70,
          new: 74
        },
        users: [],
        questions: [],
        viewFeedback: {
          collection: [],
          furthestBackTime: 0,
          initialLoadLimit: 60
        }
    }
  },
  'IS_EXAMPLE_FEEDBACK' (state) {
    state.viewState.isExampleFeedback = true
  },
  'CHANGE_NOTIFICATIONS_LOCAL' (state, user) {
    //THE ONLY EXCEPTION WHERE WE'RE NOT GOING TO
  },
  'SET_LOGIN_USER' (state, user) {
    if (typeof user !== 'undefined') {
      state.validLoggedInLoaded = true
      state.loggedInUser = {
        authID: user.authID,
        firstName: user.firstName,
        lastName: user.lastName,
        contactNumber: user.contactNumber,
        emailAddress: user.emailAddress,                        
        timeSignedUp: user.timeSignedUp,
        agencySplit: user.agencySplit,
        clientAuthDoc: user.clientAuthDoc,


        isCollaborator: user.isCollaborator,

        agencyBaseDomain: user.agencyBaseDomain,
        agencySubscription: user.agencySubscription,
        agencyEntityDocID: user.agencyEntityDocID,
        lastAccessed: user.lastAccessed,
        
        //THIS TELLS THE APP WHICH BIZZ TO FETCH:
        entityDocID: user.entityDocID,
        //THIS COULD BE ARRAY OR STRING

        //agency:
        clientNameIfAgencyClient: user.clientNameIfAgencyClient, //if not false, we are viewing a client bus.
        agency: user.agency, //the details of all agency uids
        agencyName: user.agencyName,
        
        //branding is set at the user level
        branding: user.branding,

      }
    }
  },
  'UPDATE_RESPONSE' (state, payload) {        
    state.viewData.viewFeedback.forEach((session) => {
      if (session.sessionID === payload.sessionID){
        session.journeyFeedback[payload.jFI].answer.profilePicture = payload.profilePicture
        session.journeyFeedback[payload.jFI].answer.companyLogo = payload.companyLogo
        session.journeyFeedback[payload.jFI].answer.company = payload.company
        session.journeyFeedback[payload.jFI].answer.jobTitle = payload.jobTitle
      }
    })
  },
  'SET_INVITE_HISTORY' (state, payload) {
    if (payload.startAfter) {
      state.viewData[payload.target+'InviteRecord'] = [...state.viewData[payload.target+'InviteRecord'], ...payload.docs]
    } else {
      state.viewData[payload.target+'InviteRecord'] = [...payload.docs]
    }
    
  },
  'SET_SHARE_LINK' (state, link) {
    state.viewState.currentShareLink = link
  },
  'MARK_SESSION_AS_SPAM' (state, payload){
    state.viewData.viewFeedback.forEach((session) => {
      if (session.sessionID === payload.sessionID){
        session.isSpam = true
      }
    })
  },
  'UNMARK_SESSION_AS_SPAM' (state, payload){
    state.viewData.viewFeedback.forEach((session) => {
      if (session.sessionID === payload.sessionID){
        session.isSpam = false
      }
    })
  },
  'TOGGLE_SELECTED_SHARE' (state, payload) {
    /*
    type: question, list, view
    sI
    rI
    response
    */
    let response = state.viewData[payload.type + 'Feedback']['sessions'][payload.sI]['responses'][payload.rI]

    if(typeof state.viewData[payload.type + 'Feedback']['sessions'][payload.sI]['responses'][payload.rI].selected === 'undefined'){
      state.viewState['selectedShares' + payload.type].push(response)
      state.viewData[payload.type + 'Feedback']['sessions'][payload.sI]['responses'][payload.rI].selected = true
    } else {
      let tOrF = !response.selected
      if (!tOrF) {
        state.viewState['selectedShares' + payload.type].splice(state.viewState['selectedShares' + payload.type].indexOf(response), 1)
      } else {
        state.viewState['selectedShares' + payload.type].push(response)
      }
      state.viewData[payload.type + 'Feedback']['sessions'][payload.sI]['responses'][payload.rI].selected = tOrF
    }
  },
  'SET_LIST_SHARES' (state, payload) {
    state.viewState.selectedShareslist = payload.responses
    state.viewState.selectedShareslistName = payload.listName
    state.viewState.selectedShareslistListID = payload.listID
  },
  'SET_CURRENT_PAGE' (state, payload) {
    state.viewState.page = payload
  },
  'SET_SELECTED_SHARE' (state, payload) {
    // { response, type }
    state.viewState['selectedShares' + payload.type] = [payload.response]
  },
  'UNSET_SELECTED_SHARES' (state, payload) {
    // { response, type }
    state.viewState.selectedShare = false // for one share selected
    state.viewState.selectedSharesview = []
    state.viewState.selectedShareslist = []
    state.viewState.selectedShareslistListID = []
    state.viewState.selectedShareslistName = '' // for name of list in db
    state.viewState.selectedSharesquestion = []
  },
  'LOADING_FEEDBACK' (state) {
    state.viewState.loadingFeedback = true
  },
  'FEEDBACK_LOADED' (state) {
    state.viewState.loadingFeedback = false
  },
  'LOADING_FULLSCREEN' (state, payload) {
    state.viewState.loadingFullScreen = payload
  },
  'MUTATE_APPEARANCE_INFO' (state, payload) {
    state.viewData.business.publicFeedbackDetail.appearanceInfo[payload.what] = payload.val
  },
  'MUTATE_CHOOSE_REVIEWSHARE' (state, payload) {
    state.viewData.business.publicFeedbackDetail.socialMedia[payload.what] = payload.value
  },
  'MUTATE_FEEDBACKLINK' (state, payload) {
    state.viewData.business.publicFeedbackDetail.feedbackAddressHandle = payload
  },
  'FULLSCREEN_LOADED' (state) {
    setTimeout(() => {
      state.viewState.loadingFullScreen = false
    }, 1000)
  },
  'LOAD_ANALYTICS' ( state, payload ) {

    Vue.set(state.viewData,'npsData', payload.nps)
    Vue.set(state.viewData,'csatData', payload.csat)
    Vue.set(state.viewData,'starData', payload.star)

    /*

    Before page-refresh-locations
    
    if (state.isMulti) {
      //need to modify getter
      if (payload.target === state.currentMultiLocationI) {                
        Vue.set(state.viewData,'npsData', payload.nps)
        Vue.set(state.viewData,'csatData', payload.csat)
        Vue.set(state.viewData,'starData', payload.star)
      }

      //set backstage locations
      Vue.set(state['viewData' + String(payload.target)], 'npsData', payload.nps)
      Vue.set(state['viewData' + String(payload.target)], 'csatData', payload.csat)
      Vue.set(state['viewData' + String(payload.target)], 'starData', payload.star)

      //set multilocations data
      Vue.set(state.multiLocations[payload.target],'npsData', payload.nps)
      Vue.set(state.multiLocations[payload.target],'csatData', payload.csat)
      Vue.set(state.multiLocations[payload.target],'starData', payload.star)

    } else {

        Vue.set(state.viewData,'npsData', payload.nps)
        Vue.set(state.viewData,'csatData', payload.csat)
        Vue.set(state.viewData,'starData', payload.star)

    }

    */

  },
  'MUTATE_BUSINESS_INFORMATION' (state, payload) {

    if (payload.what === 'businessContact') {
      state.viewData.business.businessInfo.businessContact.localNumber = payload.value
    } else {
      state.viewData.business.businessInfo[payload.what] = payload.value
    }

  },
  'CHANGE_MULTI_LOCATION' (state, payload) {
    //modify state to correct target i
    //noconsoleconsole.log('changing multi location in store:')
    //noconsoleconsole.log(payload)

    //noconsoleconsole.log('viewData' + String(payload))
    //noconsoleconsole.log('viewState' + String(payload))

    //reset the survey states

    //save the current state of things:
    Vue.set(state,'viewData' + String(state.currentMultiLocationI),state.viewData)
    Vue.set(state,'viewState' + String(state.currentMultiLocationI),state.viewState)

    //set the new state of things:
    Vue.set(state,'viewData',state['viewData' + String(payload)])
    Vue.set(state,'viewState',state['viewState' + String(payload)])

    state.currentMultiLocationI = payload
    //noconsoleconsole.log(state)

    if (router.currentRoute.name === 'responses') {
      //reset filters:
      //load FB and questions and showcase:
      initFBShowcaseWdgts()
    }

    //ensure that showcase IDs have been loaded
    if (!state.viewState.showcaseDataLoaded && !state.viewState.showcaseDataLoaded) {
      initFBShowcaseWdgts() 
    }

    if (router.currentRoute.name === 'showcase-setup-widget') {
      router.push('/dash/showcase')
    }

    if (router.currentRoute.name === 'survey-flow-edit') {
      router.push('/dash/surveyflow')
    }

   },
   'TOGGLE_SELECT_LOCATION' (state, payload) {
     state.showChangeLocation = payload
   },
  'SET_LANGUAGE_PACKS' (state, payload) {
    state.officialLanguagePacks = payload
    state.viewState.officalLanguagesLoaded = true
  },
  'ADD_ADDITIONAL_MULTI_LOCATIONS' (state, payload) {
    payload.forEach((mInfo) => {
      state.multiLocations.push(mInfo)
    })    
  },
  'SET_BUSINESS_STATE' (state, payload) {
    if (typeof payload !== 'undefined' && state.validLoggedInLoaded) {

      state.viewData.business = payload.busData
      state.viewState.entityLoaded = true
      state.allEntitiesLoaded = true

      if (payload.isMulti) {

        
        //set the first multi to this entity we've just loaded

        let localBussName = payload.busData.businessName
        let businessNameShort = localBussName
        if (businessNameShort.length > 15) {
          let one = localBussName.substr(0,2)
          let two = localBussName.substr(localBussName.length - 11,11)
          businessNameShort = one + ' ... ' + two
        }


        state.multiLocations = [
          {
            businessID: payload.busData.businessID,
            businessName: localBussName,
            businessNameShort,
            feedbackAddressHandle: payload.busData.publicFeedbackDetail.feedbackAddressHandle,
            npsData: false,
            i: 0
          }
        ]
        
        state.currentMultiLocationI = 0
          
         //MULTI IS NOT ALLOWED IF TRIAL IS OVER
         if (!state.isMulti &&!payload.isTrialOver) state.isMulti = true

         state.allEntitiesLoaded = true

      }


      /*

      if (payload.isMulti) {

        //noconsoleconsole.log('TARGET:')
        //noconsoleconsole.log(payload.target)

        if (payload.target === 0 && !state.allEntitiesLoaded) {
          //this is the initial load, set the current viewed business to 0
          //noconsoleconsole.log('this is the initial setting of state')
          Vue.set(state.viewData,'business',payload.busData)
          state.viewState.entityLoaded = true
          state.currentMultiLocationI = 0
        } else {
          if (payload.target === state.currentMultiLocationI) {
            //console.log('the income change affects the actual fucking viewD, so update the')
            // current viewD and the target
            Vue.set(state.viewData,'business',payload.busData)
            state['viewState'].entityLoaded = true
          }
        }

        //always update the correlating viewdata
        //noconsoleconsole.log('SETTING THE STUFF IS THE ERROR HERE?')
        //noconsoleconsole.log(state['viewData' + String(payload.target)])

        if (typeof state['viewData' + String(payload.target)] === 'undefined') {
          state['viewData' + String(payload.target)] = emptyViewData()
        }

        if (typeof state['viewState' + String(payload.target)] === 'undefined') {
          state['viewState' + String(payload.target)] = emptyViewState()
        }

        Vue.set(state['viewData' + String(payload.target)], 'business', payload.busData)
        state['viewState' + String(payload.target)].entityLoaded = true

        let localBussName = payload.busData.businessName

        let businessNameShort = localBussName

        if (businessNameShort.length > 15) {
          let one = localBussName.substr(0,2)
          let two = localBussName.substr(localBussName.length - 11,11)
          businessNameShort = one + ' ... ' + two
        }

        Vue.set(state.multiLocations,payload.target,{
         businessID: payload.busData.businessID,
         businessName: localBussName,
         businessNameShort: businessNameShort,
         feedbackAddressHandle: payload.busData.publicFeedbackDetail.feedbackAddressHandle,
         npsData: typeof state.multiLocations[payload.target] === 'undefined' ? false : state.multiLocations[payload.target].npsData,
         i: payload.target
        })

        if (payload.target + 1 === payload.noLocations) {
          state.allEntitiesLoaded = true
        }


        //MULTI IS NOT ALLOWED IF TRIAL IS OVER
        if (!state.isMulti &&!payload.isTrialOver) state.isMulti = true


      } else {
        state.viewData.business = payload.busData
        state.viewState.entityLoaded = true
        state.allEntitiesLoaded = true
      }

      */

    }
  },
  'SET_QUESTIONS' (state, questions) {
    if (typeof questions !== 'undefined' && state.validLoggedInLoaded) {
      state.viewData.questions = questions
      state.viewState.questionsLoaded = true
    }
  },
  'SET_FEEDBACK_EMPTY' (state) {
      //noconsoleconsole.log('setting feedback empty')
      state.viewData.feedbackEmpty = true
      state.viewData.feedbackChecked = true
  },
  'SET_CURRENT_LIST' (state, list) {
    if (state.viewState.currentList !== list) {
      state.viewState.currentList = list
    }
  },
  'SET_SELECTED_RESPONSE' (state, response) {
    if (state.viewState.selectedResponse !== response) {
      state.viewState.selectedResponse = response
    }
  },
  'UNSET_SELECTED_RESPONSE' (state){
    if (state.viewState.selectedResponse !== false) {
      state.viewState.selectedResponse = false
    }
  },  
  'SET_QUESTION_RESULTS' (state, payload) {     
    
    state.viewData.viewQuestionResults = payload

  },
  'SET_RESPONSES' (state, payload) {          
      state.viewData.viewFeedback = payload
      if (payload.length > 0 && state.viewData.feedbackEmpty) state.viewData.feedbackEmpty = false

  },
  'MUTATE_NOTIFICATION_PREFERENCES' (state, payload) {
    //noconsoleconsole.log(payload)
    if (!state.viewData.business.notificationPreferences) state.viewData.business.notificationPreferences = {}
    state.viewData.business.notificationPreferences[payload.what] = payload.value
  },
  'SET_INITIAL_FEEDBACK_LOADED' (state) {
    state.viewState.initialFeedbackLoaded = true
  },
  'SET_FURTHESTBACKTIME' (state, time) {
    state.viewData.viewFeedback.furthestBackTime = time
  },
  'SET_LISTS' (state, lists) {
    if (typeof lists !== 'undefined' && state.validLoggedInLoaded) {
      state.viewData.lists = lists
    }
  },
  'SHOW_MODAL' (state, modal) {
      state.viewState.modal = modal
  },
  'CLOSE_MODAL' (state) {
      state.viewState.modal = false
      state.viewState.selectedShare = false
      state.viewState.currentShareLink = false
  },
  'LOADING_SHARE_LINK' (state) {
    state.viewState.loadingShareLink = true
  },
  'RESET_DASH_STATE' (state) {
    //noconsoleconsole.log('resetting dash state')
    Object.assign(state, getDefaultState())
  },
  'SHARE_LINK_NOT_LOADING' (state) {
    state.viewState.loadingShareLink = false
  },
  'TOGGLE_WELCOME' (state) {
    state.viewState.showWelcome = !state.viewState.showWelcome
  },
  'SET_NOTIFICATION_TEXT' (state, text) {
    // Update happens too quickly
    state.viewState.notificationText = text
  },
  'CLOSE_NOTIFICATION' (state, text) {

  },
  'CLOSE_NOTIFICATION_NO_DONE' (state, text) {
    setTimeout(() => {
      state.viewState.notificationText = false
    }, 2000)
  }
}


/*















*/
